export class KeyConstants {
  static BACKSPACE_KEY = 8;
  static TAB_KEY = 9;
  static ENTER_KEY = 13;
  static SHIFT_KEY = 16;
  static CONTROL_KEY = 17;
  static ALT_KEY = 18;
  static PAUSE_KEY = 19;
  static CAPSLOCK_KEY = 20;
  static ESCAPE_KEY = 27;
  static SPACE_KEY = 32;
  static PAGE_UP_KEY = 33;
  static PAGE_DOWN_KEY = 34;
  static END_KEY = 35;
  static HOME_KEY = 36;
  static LEFT_ARROW_KEY = 37;
  static UP_ARROW_KEY = 38;
  static RIGHT_ARROW_KEY = 39;
  static DOWN_ARROW_KEY = 40;
  static PRINT_SCREEN_KEY = 44;
  static INSERT_KEY = 45;
  static DELETE_KEY = 46;
  static ZERO_KEY = 48;
  static ONE_KEY = 49;
  static TWO_KEY = 50;
  static THREE_KEY = 51;
  static FOUR_KEY = 52;
  static FIVE_KEY = 53;
  static SIX_KEY = 54;
  static SEVEN_KEY = 55;
  static EIGHT_KEY = 56;
  static NINE_KEY = 57;
  static A_KEY = 65;
  static B_KEY = 66;
  static C_KEY = 67;
  static D_KEY = 68;
  static E_KEY = 69;
  static F_KEY = 70;
  static G_KEY = 71;
  static H_KEY = 72;
  static I_KEY = 73;
  static J_KEY = 74;
  static K_KEY = 75;
  static L_KEY = 76;
  static M_KEY = 77;
  static N_KEY = 78;
  static O_KEY = 79;
  static P_KEY = 80;
  static Q_KEY = 81;
  static R_KEY = 82;
  static S_KEY = 83;
  static T_KEY = 84;
  static U_KEY = 85;
  static V_KEY = 86;
  static W_KEY = 87;
  static X_KEY = 88;
  static Y_KEY = 89;
  static Z_KEY = 90;
  static LEFT_WINDOW_KEY = 91;
  static RIGHT_WINDOW_KEY = 92;
  static SELECT_KEY = 93;
  static NUMPAD_ZERO_KEY = 96;
  static NUMPAD_ONE_KEY = 97;
  static NUMPAD_TWO_KEY = 98;
  static NUMPAD_THREE_KEY = 99;
  static NUMPAD_FOUR_KEY = 100;
  static NUMPAD_FIVE_KEY = 101;
  static NUMPAD_SIX_KEY = 102;
  static NUMPAD_SEVEN_KEY = 103;
  static NUMPAD_EIGHT_KEY = 104;
  static NUMPAD_NINE_KEY = 105;
  static MULTIPLY_KEY = 106;
  static ADD_KEY = 107;
  static SUBRACT_KEY = 109;
  static DECIMAL_POINT = 110;
  static DIVIDE_KEY = 111;
  static F1_KEY = 112;
  static F2_KEY = 113;
  static F3_KEY = 114;
  static F4_KEY = 115;
  static F5_KEY = 116;
  static F6_KEY = 117;
  static F7_KEY = 118;
  static F8_KEY = 119;
  static F9_KEY = 120;
  static F10_KEY = 121;
  static F11_KEY = 122;
  static F12_KEY = 123;
  static NUM_LOCK_KEY = 144;
  static SCROLL_LOCK_KEY = 145;
  static SEMI_COLON_KEY = 186;
  static EQUAL_SIGN_KEY = 187;
  static COMMA_KEY = 188;
  static DASH_KEY = 189;
  static PERIOD_KEY = 190;
  static FORWARD_SLASH_KEY = 191;
  static BACK_QUOTE_KEY = 192;
  static OPEN_BRACKET_KEY = 219;
  static BACK_SLASH_KEY = 220;
  static CLOSE_BRACKET_KEY = 221;
  static SINGLE_QUOTE = 222;
}
